
import React, { useEffect } from "react";
import UserInfoSkeleton from "../../clinicalNotesClinicalRoute/Skeletons/UserInfoSkeleton";
import UserInfoPanel from "../../clinicalNotesClinicalRoute/Components/UserInfoPanel";
import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";
import sign from "jwt-encode";
import { Button } from "@mui/material";
import { Add } from "@mui/icons-material";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { getUsage, updateUsageTracker } from "../../clinicalNotesClinicalRoute/lib/utils";
import { useSnackbar } from "notistack";
import SubscriptionAlertModal from "../../modals/SubscriptionAlertModal";
import NewTranscriptionDialog from "../../clinicalNotesClinicalRoute/Dialogs/NewTranscriptionDialog";
import { isAusDomain } from "../../clinicalNotesClinicalRoute/lib/utils";
const ClientInfoPanelClinicalRoute = ({
  clientDetails,
  handleChat,
  handleNotesOpen,
}) => {

  const handleBrokenImage = (imgLink) => {
    const imgLinkSplit = imgLink.split("https://");
    if (imgLinkSplit.length > 1) {
      const updatedLink = "https://" + imgLinkSplit[imgLinkSplit.length - 1];
      return updatedLink;
    } else {
      return "https://images.unitedwecare.com/odoo%2Fopen%2Fprofile-vector.webp";
    }
  };
  const [loading, setLoading] = React.useState(false);
  const [userDetails, setUserDetails] = React.useState(null);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [subscriptionModal, setSubscriptionModal] = React.useState(false);
  const [transcriptionDialog, setTranscriptionDialog] = React.useState(false);
  const [noteDetails, setNoteDetails] = React.useState(null);



  useEffect(() => {
    if (clientDetails?.id) {
      getUserDetails()

    }
  }, [clientDetails?.id])

  async function getUserDetails() {
    try {
      const response = await fetch(`https://integrations.uwc.world/users/${clientDetails?.id}/get_user_details`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log('User Details:', data);
      setUserDetails(data?.data);
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  }
  const createClinicalNoteEvent = async (responseData) => {
    setLoading(true);
    //console.log('responseData', responseData)
    try {
      const profileData = JSON.parse(localStorage.getItem("profile")); // Parse profileData if it's stored as a string

      const cred = sign(
        { user_id: `${profileData?.UserId}` },
        process.env.REACT_APP_JWT_ENCODE_SECRET || ""
      );
      // Usage limits apply to all users (like AUS system)
      const usage = await getUsage("clinical_notes", profileData?.UserId, cred)
      if (!usage.success) return
      if (!usage?.data?.value) {
        setSubscriptionModal(true)
        return
      }

      const storedData = localStorage.getItem("Authorization");
      const token = storedData ? storedData.split("Bearer ")[1] : null;
      const expertId = String(profileData?.UserId);
      const expertType = String(profileData?.UserType);
      const userId = String(responseData?.user_id);
      // console.log("response data", responseData)
      const payload = sign(
        {
          client: {
            user_id: userId,
            name: responseData?.name || clientDetails?.name,
            email: responseData?.email || clientDetails?.email,
            phone: responseData?.phone || clientDetails?.phone || "",
            his_number: responseData?.his_number || clientDetails?.his_number || "",
            image: responseData?.image || clientDetails?.image || "",
          },
          session_type: "Follow-up",
          session_date: dayjs().format("YYYY-MM-DD"),
          expert: {
            user_id: expertId,
            name: profileData?.Name,
            email: profileData?.Emailid,
            phone: profileData?.MobileNo,
            image: profileData?.ProfileImage,
            expert_type: expertType,
          },
        },
        process.env.REACT_APP_JWT_SECRET
      );
      // console.log("payload", payload)

      const body = JSON.stringify({ data: payload });

      const response = await fetch(
        `${process.env.REACT_APP_EXPERT_BASE_URL}jwt-clinicalnotes/create`,
        {
          method: "POST",
          headers: {
            "X-API-Key": process.env.REACT_APP_EXPERT_API_KEY,
            "Content-Type": "application/json",
            Token: token,
            authenticationToken: Cookies.get("authDataJwt"),
          },
          body: body, // Serialize body object to JSON
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      if (response.status === 201) {
        const jsonData = await response.json();
                   // Original code with domain check (commented out)
          // if (isAusDomain()) {
          //   const updateUsage = await updateUsageTracker("clinical_notes", profileData?.UserId, cred)
          // }

          // New code for all users
          const updateUsage = await updateUsageTracker("clinical_notes", profileData?.UserId, cred)
     
        // setCreateNewClient(false);
        // setOpen(false);
        const newData = jwtDecode(jsonData?.data);
        // // setAppointmentIDfromAPI(newData?._id);
        // // setNoteType(newData?.session_type)
        setLoading(false);
        // // setClinicalNotesState({ view: "view" });
        setNoteDetails(newData);
        setTranscriptionDialog(true);

        // Comment out navigation to open modal instead
        // const newURL = `/clinical/home?view=view&clinicalId=${newData?._id}&noteType=${newData?.session_type}`;
        // navigate(newURL);

      }
    } catch (error) {
      console.log("Error creating clinical note:", error);

    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SubscriptionAlertModal
        h1={"Upgrade to Create More Clinical Notes"}
        h2={
          "You have exhausted all your credits for this month. To create more Clinical Notes, please upgrade to a better plan."
        }
        cta1={"Upgrade Now"}
        cta2={"Upgrade Later"}
        isOpen={subscriptionModal}
        onClose={() => setSubscriptionModal(false)}
      />
      {!userDetails ? (
        <UserInfoSkeleton />
      ) : (
        <>
          <div className="d-flex align-items-center px-4">
            <div style={{ width: "150px" }} >
              <img
                src={userDetails?.image || "https://images.unitedwecare.com/odoo%2Fopen%2Fprofile-vector.webp"}
                onError={(e) => {
                  const newLink = handleBrokenImage(userDetails?.image);
                  e.target.src = newLink;
                }}
                alt=""
                className="rounded rounded-3"
                width={60}
                height={60}
                style={{
                  backgroundColor: "white",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
              />
            </div>
            <div className="p-4 d-flex w-100 flex-column gap-1">
              <div className="d-flex ">
                <h4 className="m-0">{userDetails?.name || "Client Name"}</h4>
              </div>
              <div className="d-flex flex-column gap-1">
                {userDetails?.email && (
                  <p className="fs-6 m-0 d-flex align-items-center gap-2">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.7695 1.66797H1.23047C0.552836 1.66797 0 2.2202 0 2.89844V11.1016C0 11.7775 0.550375 12.332 1.23047 12.332H12.7695C13.4455 12.332 14 11.7817 14 11.1016V2.89844C14 2.2225 13.4496 1.66797 12.7695 1.66797ZM12.5996 2.48828L7.02609 8.06184L1.40435 2.48828H12.5996ZM0.820312 10.9317V3.06439L4.77091 6.98111L0.820312 10.9317ZM1.40036 11.5117L5.35344 7.55863L6.73859 8.93189C6.89894 9.09087 7.15769 9.09035 7.31738 8.93063L8.66797 7.58004L12.5996 11.5117H1.40036ZM13.1797 10.9317L9.24801 7L13.1797 3.0683V10.9317Z"
                        fill="#807C75"
                      />
                    </svg>
                    {userDetails?.email}
                  </p>
                )}
                {(userDetails?.phone || clientDetails?.phone) && (
                  <p className="fs-6 m-0 d-flex align-items-center gap-2">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_526_4013)">
                        <path
                          d="M2.85269 9.30626C4.23354 10.9569 5.89579 12.2565 7.79301 13.1761C8.51535 13.5184 9.48137 13.9246 10.5576 13.9942C10.6243 13.9971 10.6882 14 10.7549 14C11.4772 14 12.0574 13.7505 12.5303 13.237C12.5332 13.2341 12.539 13.2283 12.5419 13.2225C12.7101 13.0195 12.9016 12.8367 13.1018 12.6424C13.2381 12.5118 13.3773 12.3755 13.5108 12.2362C14.1287 11.5922 14.1287 10.7741 13.505 10.1504L11.7615 8.40696C11.4656 8.09946 11.1117 7.93701 10.7404 7.93701C10.3691 7.93701 10.0122 8.09946 9.70764 8.40406L8.6691 9.4426C8.57337 9.38748 8.47474 9.33817 8.38191 9.29175C8.26587 9.23373 8.15853 9.17862 8.0628 9.1177C7.11709 8.5172 6.25841 7.73394 5.43744 6.72731C5.0226 6.20224 4.74411 5.76129 4.54975 5.31165C4.82244 5.06506 5.07772 4.80688 5.3243 4.5545C5.41133 4.46457 5.50126 4.37464 5.59119 4.28471C5.90449 3.9714 6.07275 3.60879 6.07275 3.24036C6.07275 2.87194 5.90739 2.50932 5.59119 2.19602L4.72671 1.33154C4.62517 1.23 4.52944 1.13137 4.43081 1.02984C4.23935 0.832574 4.03918 0.629507 3.84191 0.446747C3.54312 0.15375 3.1921 0 2.82078 0C2.45236 0 2.09844 0.153751 1.78804 0.449648L0.703084 1.5346C0.308554 1.92913 0.0851809 2.40779 0.0387656 2.96187C-0.0163525 3.6552 0.111289 4.39204 0.441998 5.28264C0.949665 6.66059 1.71552 7.93991 2.85269 9.30626ZM0.746598 3.02279C0.78141 2.63697 0.929358 2.31496 1.20785 2.03647L2.287 0.957315C2.45526 0.794861 2.64092 0.710734 2.82078 0.710734C2.99774 0.710734 3.1776 0.794861 3.34295 0.963116C3.53731 1.14298 3.72008 1.33154 3.91734 1.5317C4.01597 1.63324 4.11751 1.73477 4.21904 1.8392L5.08352 2.70369C5.26338 2.88355 5.35621 3.06631 5.35621 3.24617C5.35621 3.42603 5.26338 3.60879 5.08352 3.78865C4.99359 3.87857 4.90366 3.97141 4.81373 4.06133C4.54395 4.33402 4.29156 4.59221 4.01307 4.83879C4.00727 4.84459 4.00437 4.84749 3.99857 4.85329C3.75779 5.09407 3.7955 5.32325 3.85352 5.49731C3.85642 5.50601 3.85932 5.51181 3.86222 5.52051C4.0856 6.05719 4.396 6.56776 4.88046 7.17696C5.75074 8.25031 6.66744 9.08288 7.67697 9.724C7.80172 9.80522 7.93516 9.86904 8.0599 9.93286C8.17594 9.99088 8.28327 10.046 8.379 10.1069C8.39061 10.1127 8.39931 10.1185 8.41092 10.1243C8.50665 10.1736 8.59948 10.1969 8.69231 10.1969C8.92439 10.1969 9.07523 10.0489 9.12455 9.99959L10.2095 8.91463C10.3778 8.74637 10.5605 8.65644 10.7404 8.65644C10.9609 8.65644 11.1407 8.79279 11.2538 8.91463L13.0031 10.661C13.3512 11.0091 13.3483 11.3862 12.9944 11.7547C12.8726 11.8852 12.7449 12.0099 12.6086 12.1405C12.4055 12.3378 12.1938 12.5408 12.0023 12.77C11.6687 13.1297 11.2713 13.298 10.7578 13.298C10.7085 13.298 10.6563 13.2951 10.6069 13.2922C9.65543 13.2312 8.77063 12.8599 8.10632 12.5437C6.30192 11.6705 4.718 10.4318 3.40387 8.85951C2.32182 7.55698 1.59368 6.34438 1.11212 5.04476C0.81332 4.247 0.700183 3.60588 0.746598 3.02279Z"
                          fill="#807C75"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_526_4013">
                          <rect width="14" height="14" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    {userDetails?.phone || clientDetails?.phone}
                  </p>
                )}
              </div>
            </div>
            <div className="w-100 d-flex justify-content-end">
              <Button
                onClick={() => createClinicalNoteEvent(userDetails)}
                disabled={loading}
                sx={{
                  borderRadius: "10px", // Rounded but not too much
                  bgcolor: "var(--primary-color)",
                  color: "white",

                  textTransform: "capitalize",
                  "&:hover": {
                    background: "var(--primary-color-darken)",
                  },
                  "&:disabled": {
                    background: "var(--primary-color-opacity50)",
                    color: "white",
                  },
                }}
                className="d-flex align-items-center gap-2 px-3 py-2"
                id=""
              >
                <Add />
                Create Clinical Note
              </Button>
            </div>
          </div>
        </>
        // <UserInfoPanel />
      )}
      
      {/* Transcription Dialog Modal */}
      <NewTranscriptionDialog
        open={transcriptionDialog}
        handleClose={() => setTranscriptionDialog(false)}
        onSuccess={(data) => {
          // Handle successful note creation
          const newURL = `/clinical/home?view=view&clinicalId=${noteDetails?._id}&noteType=${noteDetails?.session_type}`;
          navigate(newURL);
          setTranscriptionDialog(false);
        }}
        data={noteDetails}
      />
    </>
  );
};

export default ClientInfoPanelClinicalRoute;
